import { render, staticRenderFns } from "./sub-num-content.vue?vue&type=template&id=5cb19b5c&scoped=true&"
import script from "./sub-num-content.vue?vue&type=script&lang=js&"
export * from "./sub-num-content.vue?vue&type=script&lang=js&"
import style0 from "./sub-num-content.vue?vue&type=style&index=0&id=5cb19b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb19b5c",
  null
  
)

export default component.exports